import {
    FETCH_MENU_DETAILS_REQUEST,
    FETCH_MENU_DETAILS_SUCCESS,
    FETCH_MENU_DETAILS_FAILURE
} from '../constants/menuActionTypes';

const initialState = {
    menuItems: [],
    error: {},
    searchVisibility: 'block'
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case FETCH_MENU_DETAILS_REQUEST:
            return {
                ...state,
                searchVisibility: 'block'
            };
        case FETCH_MENU_DETAILS_SUCCESS:
            return {
                ...state,
                menuItems: action.payload,
                searchVisibility: 'none'
            };
        case FETCH_MENU_DETAILS_FAILURE:
            return {
                ...state,
                searchVisibility: 'none'
            };
        default:
            return state;
    }
}
